import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { MarketDetail, MarketMetrics } from '~/core/model';

@Component({
  selector: 'idap-market-table-row',
  templateUrl: './market-table-row.component.html',
  styleUrls: ['./market-table-row.component.scss']
})
export class MarketTableRowComponent implements OnInit, OnDestroy {
  @Input() public market: MarketDetail;
  @Output() onMarketSelected: EventEmitter<MarketDetail> = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  ngOnDestroy() {
    this.onMarketSelected.complete();
  }

  selectMarket(market: MarketDetail) {
    this.onMarketSelected.next(market);
  }
}



// WEBPACK FOOTER //
// ./src/app/features/market/components/tables/market-table-row.component.ts